import { Component, Input } from '@angular/core';
import { Error } from './error.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  @Input() configuration: Error = new Error();

  constructor(private router: Router) {}

  onSubmit() {
    this.setWindowLocation();
  }

  setWindowLocation() {
    if (this.configuration.link?.url.includes('https://')) {
      window.location.href = this.configuration.link.url;
    } else {
      const url = 'abrir-cdt-avvillas' + this.configuration.link?.url;
      window.location.href = url;
    }
  }

  redirect(url: string, queryParams?: object) {
    if (queryParams !== undefined) {
      this.router.navigate([url], {
        queryParams
      });
    } else {
      this.router.navigate([url]);
    }
  }
}
